"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Boracay", {
  enumerable: true,
  get: function get() {
    return _Boracay["default"];
  }
});
Object.defineProperty(exports, "Guyam", {
  enumerable: true,
  get: function get() {
    return _Guyam["default"];
  }
});
Object.defineProperty(exports, "Corregidor", {
  enumerable: true,
  get: function get() {
    return _Corregidor["default"];
  }
});
Object.defineProperty(exports, "Siquijor", {
  enumerable: true,
  get: function get() {
    return _Siquijor["default"];
  }
});
Object.defineProperty(exports, "Palawan", {
  enumerable: true,
  get: function get() {
    return _Palawan["default"];
  }
});
Object.defineProperty(exports, "Cebu", {
  enumerable: true,
  get: function get() {
    return _Cebu["default"];
  }
});
Object.defineProperty(exports, "Malalison", {
  enumerable: true,
  get: function get() {
    return _Malalison["default"];
  }
});
Object.defineProperty(exports, "Panay", {
  enumerable: true,
  get: function get() {
    return _Panay["default"];
  }
});
Object.defineProperty(exports, "Bohol", {
  enumerable: true,
  get: function get() {
    return _Bohol["default"];
  }
});
Object.defineProperty(exports, "Polillo", {
  enumerable: true,
  get: function get() {
    return _Polillo["default"];
  }
});
Object.defineProperty(exports, "Pescador", {
  enumerable: true,
  get: function get() {
    return _Pescador["default"];
  }
});
Object.defineProperty(exports, "Luzon", {
  enumerable: true,
  get: function get() {
    return _Luzon["default"];
  }
});
Object.defineProperty(exports, "Balabac", {
  enumerable: true,
  get: function get() {
    return _Balabac["default"];
  }
});
Object.defineProperty(exports, "Babuyan", {
  enumerable: true,
  get: function get() {
    return _Babuyan["default"];
  }
});
Object.defineProperty(exports, "Leyte", {
  enumerable: true,
  get: function get() {
    return _Leyte["default"];
  }
});
Object.defineProperty(exports, "Lubang", {
  enumerable: true,
  get: function get() {
    return _Lubang["default"];
  }
});
Object.defineProperty(exports, "Mindoro", {
  enumerable: true,
  get: function get() {
    return _Mindoro["default"];
  }
});
Object.defineProperty(exports, "Negros", {
  enumerable: true,
  get: function get() {
    return _Negros["default"];
  }
});
Object.defineProperty(exports, "Siargao", {
  enumerable: true,
  get: function get() {
    return _Siargao["default"];
  }
});
Object.defineProperty(exports, "Ticao", {
  enumerable: true,
  get: function get() {
    return _Ticao["default"];
  }
});

var _Boracay = _interopRequireDefault(require("./Boracay"));

var _Guyam = _interopRequireDefault(require("./Guyam"));

var _Corregidor = _interopRequireDefault(require("./Corregidor"));

var _Siquijor = _interopRequireDefault(require("./Siquijor"));

var _Palawan = _interopRequireDefault(require("./Palawan"));

var _Cebu = _interopRequireDefault(require("./Cebu"));

var _Malalison = _interopRequireDefault(require("./Malalison"));

var _Panay = _interopRequireDefault(require("./Panay"));

var _Bohol = _interopRequireDefault(require("./Bohol"));

var _Polillo = _interopRequireDefault(require("./Polillo"));

var _Pescador = _interopRequireDefault(require("./Pescador"));

var _Luzon = _interopRequireDefault(require("./Luzon"));

var _Balabac = _interopRequireDefault(require("./Balabac"));

var _Babuyan = _interopRequireDefault(require("./Babuyan"));

var _Leyte = _interopRequireDefault(require("./Leyte"));

var _Lubang = _interopRequireDefault(require("./Lubang"));

var _Mindoro = _interopRequireDefault(require("./Mindoro"));

var _Negros = _interopRequireDefault(require("./Negros"));

var _Siargao = _interopRequireDefault(require("./Siargao"));

var _Ticao = _interopRequireDefault(require("./Ticao"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }